module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_long_front_vector.6b4279db.svg";